const LOCALFORAGE_WARNING = 'Redefining LocalForage driver: memoryStorageDriver';

const shouldIgnoreMessage = (args) => {
  if (!args || !args.length) {
    return false;
  }
  const first = args[0];
  return typeof first === 'string' && first.includes(LOCALFORAGE_WARNING);
};

if (typeof window !== 'undefined' && window.console && !window.__fcMfeConsoleFilterInstalled) {
  window.__fcMfeConsoleFilterInstalled = true;
  ['warn', 'info', 'log'].forEach((method) => {
    const original = window.console[method];
    if (typeof original !== 'function') {
      return;
    }
    window.console[method] = (...args) => {
      if (shouldIgnoreMessage(args)) {
        return;
      }
      return original.apply(window.console, args);
    };
  });
}
